import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { alpha, useTheme } from '@mui/material/styles'
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded'
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded'
import { useTranslation } from 'react-i18next'
import { useThemeMode } from '@/theme/ThemeModeProvider'

const ThemeModeToggle = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { mode, toggleColorMode } = useThemeMode()
  const isDark = mode === 'dark'
  const ActiveIcon = isDark ? DarkModeRoundedIcon : LightModeRoundedIcon
  const switchThemeTitle = t(isDark ? 'switch_to_light_mode' : 'switch_to_dark_mode')
  
  return (
    <Tooltip 
      title={switchThemeTitle}
      placement="top-start"
    >
      <IconButton
        onClick={toggleColorMode}
        aria-label={switchThemeTitle}
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          backgroundColor: alpha(theme.palette.primary.main, 0.08),
          color: 'text.primary',
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.16)
          }
        }}
      >
        <ActiveIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  )
}

export default ThemeModeToggle